import Vue from 'vue';
const constructor = Vue.extend(require('./PopupToast.vue').default);
const Message = (options)=>{
    options = options || {};
    if(typeof options === "string"){
        options = {
            text: options
        }
    }
    const instance = new constructor({
        data:options
    })
    instance.$mount();
    document.body.appendChild(instance.$el)
    instance.visible = true;
    return instance
}

export default Message;